import React from 'react';
import { IAcordo, IParcelaAcordo } from 'interfaces/Acordo';
import 
{ 
    Button, 
    Dialog, 
    DialogContent, 
    DialogContentText, 
    DialogTitle, 
    Divider, 
    Grid,
    Typography, 
} from '@mui/material';
import { ICustomizacao } from 'interfaces/Customizacao';
import PopUpButtons from './PopUpButtons';
import CloseIcon from '@mui/icons-material/Close';
import parse from 'html-react-parser'

interface IDividaItemProps
{
  acordo: IAcordo | null;
  item: IParcelaAcordo | null;
  custom: ICustomizacao | undefined;
  popUpOpen: any;
  setPopUpOpen: any;
}

function PopUpBoleto({ item, acordo, custom, popUpOpen, setPopUpOpen}: IDividaItemProps) {
  
  const [legenda, setLegenda] = React.useState(true);

    const handleClose = () => {
      setPopUpOpen(false);
    };

    const legendaClose = () => {
        setLegenda(false);
    }

    const legendaOpen = () => {
        setLegenda(true);
    }

    return (
        <div>
          <Dialog
            open={popUpOpen}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="xs"
          >   
            <DialogTitle>
              <Grid container>
                <Grid item xs={10} sm={10} lg={10}>
                  <strong>2ª Via do Boleto</strong>
                </Grid>
                <Grid item xs={2} sm={2} lg={2} style={{display: 'flex', justifyContent:' flex-end', alignItems: 'center'}}>
                    <Button style={{padding: 0, minWidth: 0}} onClick={handleClose}><CloseIcon/></Button>
                </Grid>
            </Grid>
            </DialogTitle>
            <DialogContent>
            <Divider/>
              <DialogContentText style={{ color: "#6C757D" }}>
                {custom && (custom?.SenhaBoleto && (
                  <Typography style={{fontSize: 14, marginTop: "3%"}}>
                    {parse(custom?.SenhaBoleto || "")}
                  </Typography>
                ))}
              {legenda && (
                <><br/>De <strong>qual forma você quer obter</strong> a 2ª via do seu boleto de pagamento?</>
              )}
              </DialogContentText>

              <PopUpButtons item={item} acordo={acordo} onClose={handleClose} legendaClose={legendaClose} legendaOpen={legendaOpen}/>
              
            </DialogContent>
          </Dialog>
        </div>
)}

export default PopUpBoleto;